export default "__VITE_ASSET__CXCBRB$N__"